module.exports = __webpack_public_path__ + "static/media/thumb.e3127c34.jpg";